(function () {
  'use strict';

  document.querySelectorAll('[data-fv-track-form]').forEach(function (form) {
    if (form.dataset.fvTrackReady === '1') return;
    form.dataset.fvTrackReady = '1';

    var api = String(form.getAttribute('data-fv-track-api') || '').replace(/\/+$/, '');
    var button = form.querySelector('[data-fv-track-submit]');
    var feedback = form.querySelector('[data-fv-track-feedback]');
    var result = form.querySelector('[data-fv-track-result]');
    var account = document.querySelector('[data-fv-track-account]');

    function accountToken() {
      try {
        return window.localStorage.getItem('furniva:account:token') || '';
      } catch (_) {
        return '';
      }
    }

    /** A Worker request carrying this device's session, via the account script when it is there. */
    function call(path) {
      if (window.FurnivaAccount && typeof window.FurnivaAccount.request === 'function') {
        return window.FurnivaAccount.request(path);
      }
      return fetch(api + path, {
        headers: { Accept: 'application/json', Authorization: 'Bearer ' + accountToken() },
        credentials: 'omit',
        mode: 'cors'
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          return { status: response.status, data: data || {} };
        });
      });
    }

    function showAccount(signedIn) {
      form.hidden = signedIn;
      if (account) account.hidden = !signedIn;
      if (signedIn) loadOrders();
    }

    /**
     * The signed-in customer's recent orders, drawn in place. The Worker
     * renders the markup (escaped there, as in the account panel) from the
     * session's own customer — nothing here names a customer. If it cannot be
     * fetched, the guest form comes back rather than an empty box.
     */
    function loadOrders() {
      var holder = account && account.querySelector('[data-fv-track-orders]');
      if (!holder || holder.dataset.fvLoaded === '1') return;
      holder.dataset.fvLoaded = '1';
      call('/api/view?name=track').then(function (response) {
        if (response.status === 200 && response.data && response.data.ok && response.data.html) {
          holder.innerHTML = response.data.html;
        } else {
          showAccount(false);
        }
      }).catch(function () {
        showAccount(false);
      });
    }

    var other = account && account.querySelector('[data-fv-track-other]');
    if (other) {
      other.addEventListener('click', function () {
        form.hidden = false;
        other.hidden = true;
        var first = form.querySelector('input');
        if (first) first.focus();
      });
    }

    /**
     * Ask the same Worker that issued the session. A network failure leaves the
     * guest lookup available; it never blocks a customer from finding an order.
     */
    function resolveSession() {
      if (!accountToken()) {
        showAccount(false);
        return;
      }

      var request = call('/api/me');

      request.then(function (response) {
        var signedIn = Boolean(response.data && response.data.ok && response.data.signedIn);
        if (!signedIn && window.FurnivaAccount && typeof window.FurnivaAccount.clearSession === 'function') {
          window.FurnivaAccount.clearSession();
        }
        showAccount(signedIn);
      }).catch(function () {
        showAccount(false);
      });
    }

    function message(text, isError) {
      feedback.textContent = text || '';
      feedback.hidden = !text;
      feedback.className = 'fv-feedback' + (isError ? ' fv-feedback--error' : '');
    }

    function el(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text) node.textContent = text;
      return node;
    }

    function safeUrl(raw) {
      try {
        var target = new URL(raw);
        return target.protocol === 'https:' || target.protocol === 'http:' ? target.href : '';
      } catch (_) {
        return '';
      }
    }

    var whenFmt = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone: 'Asia/Kolkata' });
    var dayFmt = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', timeZone: 'Asia/Kolkata' });
    function when(raw) {
      var text = String(raw || '');
      // A bare date is a day (a dispatch day has no time); courier times carry
      // no zone and are India time.
      if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return dayFmt.format(new Date(text + 'T12:00:00+05:30'));
      var zoned = /[zZ]|[+-]\d\d:?\d\d$/.test(text) || text.indexOf('T') < 0 ? text : text + '+05:30';
      var d = new Date(zoned);
      return isNaN(d.getTime()) ? text : whenFmt.format(d);
    }

    function progress(item) {
      var wrap = el('div', 'fv-track-progress');
      var head = el('div', 'fv-track-progress__head');
      head.appendChild(el('strong', '', item.label || item.stages[item.stage] || ''));
      if (item.expected && item.stage < 3) {
        head.appendChild(el('span', 'fv-hint', 'Expected by ' + new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short' }).format(new Date(item.expected))));
      }
      wrap.appendChild(head);
      var steps = el('ol', 'fv-track-progress__steps');
      item.stages.forEach(function (name, i) {
        var step = el('li', 'fv-track-progress__step' + (i < item.stage ? ' is-done' : i === item.stage ? ' is-current' : ''));
        step.appendChild(el('span', 'fv-track-progress__dot'));
        step.appendChild(el('span', 'fv-track-progress__name', name));
        steps.appendChild(step);
      });
      wrap.appendChild(steps);
      return wrap;
    }

    function timeline(events) {
      var list = el('ol', 'fv-track-tl');
      events.forEach(function (event, i) {
        var li = el('li', 'fv-track-tl__item' + (i === 0 ? ' is-latest' : ''));
        var body = el('div', 'fv-track-tl__body');
        body.appendChild(el('strong', 'fv-track-tl__title', event.title));
        var meta = [when(event.at), event.place].filter(Boolean).join(' · ');
        if (meta) body.appendChild(el('span', 'fv-track-tl__meta', meta));
        if (event.note) body.appendChild(el('span', 'fv-track-tl__note', event.note));
        li.appendChild(body);
        list.appendChild(li);
      });
      return list;
    }

    function showOrder(data) {
      result.replaceChildren();
      var card = el('div', 'fv-track-result');
      var head = el('div', 'fv-track-result__head');
      head.appendChild(el('strong', 'fv-track-result__order', data.order));
      head.appendChild(el('span', 'fv-track-result__status', data.status));
      card.appendChild(head);
      if (data.placedAt) {
        card.appendChild(el('span', 'fv-hint', 'Placed ' + new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(data.placedAt))));
      }

      var shipments = data.tracking || [];
      if (shipments.length) {
        var list = el('div', 'fv-track-result__ships');
        shipments.forEach(function (item) {
          var row = el('div', 'fv-track-result__ship');
          var text = el('div', 'fv-track-result__awb');
          text.appendChild(el('span', 'fv-hint', item.company || 'Courier'));
          if (item.number) text.appendChild(el('span', 'fv-track-result__number', item.number));
          row.appendChild(text);
          var href = safeUrl(item.url);
          if (href) {
            var link = el('a', 'fv-btn fv-btn--secondary fv-btn--sm', 'Track with ' + (item.company || 'the courier'));
            link.href = href;
            link.target = '_blank';
            link.rel = 'noopener';
            row.appendChild(link);
          }
          var parcel = el('div', 'fv-track-parcel');
          parcel.appendChild(row);
          if (item.stages && item.stages.length) parcel.appendChild(progress(item));
          if (item.waitingForCourier) {
            parcel.appendChild(el('p', 'fv-hint', 'Handed to ' + (item.company || 'the courier') + '. Their first scan usually shows here within a day.'));
          }
          if (item.events && item.events.length) parcel.appendChild(timeline(item.events));
          list.appendChild(parcel);
        });
        card.appendChild(list);
      } else {
        card.appendChild(el('p', 'fv-hint', 'Tracking appears here once the order is dispatched.'));
      }
      result.appendChild(card);
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(form);
      message('Looking up your order…', false);
      result.hidden = true;
      button.disabled = true;

      fetch(api + '/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ order: data.get('order') || '', phone: data.get('phone') || '' })
      })
        .then(function (response) { return response.json(); })
        .then(function (payload) {
          if (!payload.ok) throw new Error(payload.error || 'We could not find that order.');
          message('', false);
          showOrder(payload);
        })
        .catch(function (error) {
          result.hidden = true;
          message(error.message || 'We could not find that order.', true);
        })
        .then(function () { button.disabled = false; });
    });

    resolveSession();
  });
})();
